import { Box, type BoxProps } from '@mui/material';
import COLORS from '@/resources/style/Themes';

// Native <svg>, not MUI SvgIcon: SvgIcon's CSS `fill: currentColor` inherits onto
// child paths and overrides fill="none", turning the open exit-arrow chevron into
// a solid triangle. src/resources/images/left-org.svg is the design export.
const LEFT_ORG_ICON_HEIGHT_PX = 16;
const LEFT_ORG_ICON_WIDTH_PX = 22;

type LeftOrgIconProps = {
  sx?: BoxProps['sx'];
};

const LeftOrgIcon = ({ sx }: LeftOrgIconProps) => (
  <Box
    component="svg"
    viewBox="0 0 296 219"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    sx={{
      color: COLORS.GREY,
      height: LEFT_ORG_ICON_HEIGHT_PX,
      width: LEFT_ORG_ICON_WIDTH_PX,
      display: 'block',
      flexShrink: 0,
      overflow: 'visible',
      ...sx,
    }}
  >
    <path
      d="M120.3 98.1111H169.74M120.3 212V43.4444C120.3 30.6877 120.3 24.3093 118.055 19.4369C116.08 15.1509 112.928 11.6664 109.052 9.48266C104.646 7 98.877 7 87.34 7H50.26C38.723 7 32.9544 7 28.5478 9.48266C24.6716 11.6664 21.5202 15.1509 19.5453 19.4369C17.3 24.3093 17.3 30.6877 17.3 43.4444V212M213 212H7M53.35 52.5556H84.25M53.35 98.1111H84.25M53.35 143.667H84.25M202 205V191V181.5V167"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M158 143.607H283M241.599 179L283 143.607L241.599 109"
      fill="none"
      stroke="currentColor"
      strokeWidth="16"
      strokeLinecap="round"
    />
    <path
      d="M193.543 120.773C193.97 124.615 197.431 127.384 201.273 126.957C205.115 126.53 207.884 123.069 207.457 119.227L200.5 120L193.543 120.773ZM168.377 98.1037L168.377 105.104C180.726 105.104 186.329 107.196 189.05 109.415C191.499 111.412 192.849 114.527 193.543 120.773L200.5 120L207.457 119.227C206.651 111.973 204.736 104.14 197.896 98.564C191.328 93.2091 181.62 91.1037 168.377 91.1037L168.377 98.1037Z"
      fill="currentColor"
    />
  </Box>
);

export default LeftOrgIcon;
